import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({

  providedIn: 'root'

})

export class GurdServiceService {

  encryptionKey = environment.encryptionKey;

  constructor() { }

  getToken() {

    return !!localStorage.getItem("db30a17f18d1a8a3l0ifr4z8ab0b02");

  }

  getToken_2() {

    return !!localStorage.getItem("db31a17f18d1a8a3l0ifrEz8abJb02");

  }

  encrypt(value: string | number): string {

    return CryptoJS.AES.encrypt(value.toString(), this.encryptionKey).toString();

  }

  decrypt(value: any): string {

    return value != null ? CryptoJS.AES.decrypt(value, this.encryptionKey).toString(CryptoJS.enc.Utf8) : '';

    // try {

    //   return value != null ? CryptoJS.AES.decrypt(value, this.encryptionKey).toString(CryptoJS.enc.Utf8) : '';

    // } catch (error) {

    //   window.localStorage.clear();

    //   this.router.navigate(['/login']);

    //   this.notificationService.showError('خطایی رخ داده است , لطفا مجددا وارد شوید');

    //   return ''

    // }

  }

}
